import { render, staticRenderFns } from "./EditDelivery.vue?vue&type=template&id=855d935a"
import script from "./EditDelivery.vue?vue&type=script&lang=js"
export * from "./EditDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports